import { isDarkTheme } from '@/constants/Colors';

/**
 * Distinct dashed user-bubble look for temporary chats (ChatGPT-style).
 * Light: soft blue fill + dashed blue border. Dark: translucent blue on the
 * elevated bubble so the dashed outline still reads.
 */
export function getTemporaryUserBubbleStyle(theme) {
  const dark = isDarkTheme(theme);
  return {
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: dark ? 'rgba(126, 182, 232, 0.9)' : '#8BB8E0',
    backgroundColor: dark ? 'rgba(26, 135, 255, 0.18)' : '#E8F4FF',
  };
}
